// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .formClass{
    display: flex !important;
  } */
/* .formClass .css-7i8dph-MuiFormControl-root-MuiTextField-root{
    width: 300px !important;
    margin: 10px 5%;
  } */

  .css-1huayr9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{
    margin: 10px 5%;
  }`, "",{"version":3,"sources":["webpack://./src/components/coupon/style.css"],"names":[],"mappings":"AAAA;;KAEK;AACL;;;KAGK;;EAEH;IACE,eAAe;EACjB","sourcesContent":["/* .formClass{\n    display: flex !important;\n  } */\n/* .formClass .css-7i8dph-MuiFormControl-root-MuiTextField-root{\n    width: 300px !important;\n    margin: 10px 5%;\n  } */\n\n  .css-1huayr9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{\n    margin: 10px 5%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
